export enum ChainTokenTradeableCategory {
  UNKNOWN, // no check done
  NOT_TRADEABLE, // check done - not tradeable
  BAD_LIQUIDITY, // check done - bad liquidity (>1% price impact) on all sources
  MIXED_LIQUIDITY, // check done - mixed liquidity (>1% price impact on at least one but not all sources)
  TRADEABLE, // check done - price impact on all sources < 1%
}
